"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var SoundOff = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M8.74898127,16 L5,16 C4.44771525,16 4,15.5522847 4,15 L4.00509158,9.99898179 C4.00565351,9.44709492 4.4532039,9 5.00509106,9 L8.74898127,9 L13.0061088,6 L14.0061088,6 L14.0061088,19 L12.9989813,19 L8.74898127,16 Z M5.00610875,10 L4.99898127,15 L7.99898127,15 L7.99898127,10 L5.00610875,10 Z M8.99898127,10 L8.99898127,15 L12.9989813,17.75 L12.9989813,7.25 L8.99898127,10 Z M16.1502241,14.8626178 C15.9548917,14.6672854 15.954697,14.350649 16.1497892,14.1550767 L17.8258664,12.4748737 L16.1548072,10.8468646 L16.1502241,10.8423409 C15.9574933,10.6496102 15.9574933,10.3371319 16.1502241,10.1444011 C16.346228,9.94839714 16.6633692,9.94632801 16.8619139,10.1397578 L18.5329731,11.767767 L20.1488917,10.1451334 L20.1496225,10.1444011 C20.3444802,9.9495434 20.6604069,9.9495434 20.8552646,10.1444011 C21.0506453,10.3397817 21.0509736,10.6564549 20.8559985,10.8522402 L19.2400799,12.4748737 L20.8610921,14.149778 C21.0540486,14.3491496 21.0514549,14.6664276 20.8552646,14.8626178 C20.853369,14.8645134 20.851458,14.8663935 20.8495317,14.8682578 C20.6543213,15.057187 20.3429146,15.0520952 20.1539854,14.8568848 L18.5329731,13.1819805 L16.856896,14.8621834 L16.8564622,14.8626178 C16.6614399,15.0576401 16.3452463,15.0576401 16.1502241,14.8626178 Z" })));
};
SoundOff.displayName = 'SoundOff';
exports.default = SoundOff;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=SoundOff.js.map